import { render, staticRenderFns } from "./breadcrumb-sourcing.vue?vue&type=template&id=554bd5f2&scoped=true"
import script from "./breadcrumb-sourcing.vue?vue&type=script&lang=js"
export * from "./breadcrumb-sourcing.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb-sourcing.vue?vue&type=style&index=0&id=554bd5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554bd5f2",
  null
  
)

export default component.exports